var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('vv-loading',{attrs:{"is-loading":_vm.isLoading}}),_c('download-message',{attrs:{"loading":_vm.isLoading,"removed":_vm.removed,"type":_vm.type,"date":_vm.date,"expire_date":_vm.expire_date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }